const RcaNavCheckIcon = () => (
  <svg fill="currentColor" viewBox="0 0 20 20">
    <path d="M16.707 5.293a1 1 0 0 1 0 1.414l-8 8a1 1 0 0 1-1.414 0l-4-4a1 1 0 0 1 1.414-1.414L8 12.586l7.293-7.293a1 1 0 0 1 1.414 0z" />
  </svg>
);

export default RcaNavCheckIcon;
